// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"b4bf1272","402":"2bf7149d","453":"ff7866cb","497":"70565851","632":"21e31809","737":"e77ef7ad","789":"d32560a4","956":"3cfdeb6d"}[chunkId] + ".chunk.js";
};